import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";
import Header from './AuthPage/Header'





function TeamInvitationWrapper(props) {
  const {children} = props
  return (
    _jsxs('div', { className: "flex min-h-full max-w-full flex-1 flex-col items-center overflow-auto bg-slate-200 text-slate-700"        , children: [
      _jsx(Header, {} )
      , _jsx('div', { className: "maxw-full flex w-full flex-1 flex-col items-center px-4 py-8"       , children: children})
    ]})
  )
}

export default TeamInvitationWrapper
